import { orderBy, query } from 'firebase/firestore';
import { useMemo } from 'react';
import { useCollection } from '@/lib/firestore/hooks';
import { usersCol } from '@/lib/firestore/refs';
import type { UserProfile } from '@shared/types';

export function useUsers() {
  const { data, loading } = useCollection<UserProfile>(useMemo(() => query(usersCol(), orderBy('name')), []), []);
  const byId = useMemo(() => new Map(data.map((u) => [u.uid, u])), [data]);
  return { users: data, byId, loading };
}
